const type = {
  adminLogInSuccess: "adminLogInSuccess",
  adminLogOutSuccess: "adminLogOutSuccess",
  getAdminToken: "getAdminToken",
};

export default type;
